import {useState} from 'react';

import {Navigate, useNavigate, useParams} from 'react-router-dom';

import {Box, Grow} from '@mui/material';

import {useTalentSurveyPage} from './useTalentSurveyPage';
import {useUserData} from '../../../contexts/UserContext/useUserData';
import {TalentService} from '../../../features/talent/services/TalentService';
import Questionnaire from '../../../features/talent/survey/components/Questionnaire';
import {SurveyCompletedMessage} from '../../../features/talent/survey/components/SurveyCompletedMessage';
import {TalentSurvey} from '../../../features/talent/types';
import {AppConfig} from '../../../lib/AppConfig';

export const TalentSurveyWithIdPage = () => {
  const {isUserLoggedIn} = useUserData();
  const urlParams = useParams();
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const talentSurveyId = urlParams.talent_survey_id ?? '';
  const params = new URLSearchParams(window.location.search);
  const isScreeningSurvey = params.get('source') === 'screening_applicant';

  const {data, loading, error} = useTalentSurveyPage(talentSurveyId);

  const handleOnSubmit = (talentSurvey: TalentSurvey) => {
    TalentService.submitTalentSurvey(talentSurvey).then(() => {
      setIsSubmitted(true);
      if (!isScreeningSurvey) {
        if (isUserLoggedIn()) {
          return navigate(AppConfig.APPLICANT_CULTURE_PATH);
        }
        return navigate(`${AppConfig.SIGN_UP_PATH}${talentSurvey.id}`);
      }
    });
  };

  if (loading || !data) {
    return <></>;
  }

  if (error) {
    return <Navigate to={AppConfig.HOME_PATH} />;
  }

  // Skip the survey if it's already completed
  if (data.completedAt) {
    return <Navigate to={AppConfig.HOME_PATH} />;
  }

  const ThankYouComponent = () => (
    <Grow in style={{transformOrigin: '0 10 0'}} timeout={1200}>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <SurveyCompletedMessage />
      </Box>
    </Grow>
  );

  return (
    <>
      {isSubmitted ? (
        <ThankYouComponent />
      ) : (
        <Questionnaire talentSurvey={data} onSubmit={handleOnSubmit} isScreeningSurvey={isScreeningSurvey} />
      )}
    </>
  );
};
